/**
 * @author Falk Brueckner <fabr@fabid.de>
 */

const win = window as any;
win.appState = win.appState ? win.appState : {};
const state = win.appState;

type possibleKeys = 'viewportWidth' | 'wasPersistedPageShow';

/**
 * class for storing global/app state variables; use as cheap Redux alternative
 */
class AppState {
    /**
     * Get app state variable
     *
     * @param key {string}
     * @returns {any}
     */
    public get(key: possibleKeys): any {
        return state[key];
    }

    /**
     * Set app state variable
     *
     * @param key {string}
     * @param value {any}
     * @returns {void}
     */
    public set(key: possibleKeys, value: any): void {
        state[key] = JSON.parse(JSON.stringify(value)); // deep copy
    }
}

export default new AppState();
